import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EventManager, JhiLanguageService, AlertService} from 'ng-jhipster';

import { Reservation } from './reservation.model';
import { ReservationPopupService } from './reservation-popup.service';
import { ReservationService } from './reservation.service';
import { CRUD_ACTIONS, Principal} from '../../shared/index';
import { HttpErrorResponse } from '@angular/common/http';
import { AbstractDialogComponent } from '../abstract-dialog-component/abstract-dialog.component';
import { School, SchoolService } from '../school';

@Component({
    selector: 'jhi-reservation-unlink-dialog',
    templateUrl: './reservation-unlink-dialog.component.html'
})
export class ReservationUnlinkDialogComponent extends AbstractDialogComponent {

    reservation: Reservation;

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private reservationService: ReservationService,
        public activeModal: NgbActiveModal,
        private eventManager: EventManager,
        protected schoolService: SchoolService,
        protected alertService: AlertService,
        protected principal: Principal
    ) {
        super(schoolService, alertService, principal);
    }

    clear() {
        this.activeModal.dismiss('cancel');
    }

    confirmUnlink() {
        this.reservation.card = null;
         this.reservationService.update(this.reservation, true, true)
                                .subscribe(
                                    (res: Reservation) => this.onSaveSuccess(res, CRUD_ACTIONS.UPDATE)
                                    , (error: HttpErrorResponse) =>  this.onError(error));
    }

    private onSaveSuccess(result: Reservation,  action: String) {
        this.eventManager.broadcast({ name: 'reservationListModification', content: {
            action: action,
            content: result
            }
        });

        this.activeModal.dismiss(result);
    }
}

@Component({
    selector: 'jhi-reservation-unlink-popup',
    template: ''
})
export class ReservationUnlinkPopupComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor(
        private route: ActivatedRoute,
        private reservationPopupService: ReservationPopupService
    ) { }

    ngOnInit() {
        this.routeSub = this.route.params.subscribe(params => {
            this.modalRef = this.reservationPopupService
                .open(ReservationUnlinkDialogComponent as Component, params['id']);
        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/reservation/reservation-unlink-dialog.component.ts